import { render, staticRenderFns } from "./EditableListItem.vue?vue&type=template&id=f52c0cd6&"
import script from "./EditableListItem.vue?vue&type=script&lang=js&"
export * from "./EditableListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports